// extracted by mini-css-extract-plugin
export var chip = "_cf-0";
export var filterDropdown = "_cf-5";
export var filterItem = "_cf-6";
export var icon = "_cf-1";
export var removeButton = "_cf-3";
export var removeIcon = "_cf-4";
export var separator = "_cf-2";